__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "office-addin-taskpane-react";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.13.3", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(187), __webpack_require__.e(232)]).then(() => (() => (__webpack_require__(3187))))));
			register("@mui/material", "5.16.7", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(892), __webpack_require__.e(242), __webpack_require__.e(232), __webpack_require__.e(476), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(892))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(325), __webpack_require__.e(232)]).then(() => (() => (__webpack_require__(8325))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(28), __webpack_require__.e(232), __webpack_require__.e(476)]).then(() => (() => (__webpack_require__(7028))))));
			register("react-router-dom", "7.5.0", () => (Promise.all([__webpack_require__.e(912), __webpack_require__.e(232), __webpack_require__.e(476)]).then(() => (() => (__webpack_require__(3912))))));
			register("react", "18.3.1", () => (__webpack_require__.e(696).then(() => (() => (__webpack_require__(3696))))));
			initExternal(109);
			initExternal(5189);
			initExternal(4777);
			initExternal(8456);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};